export const getCityAndLocation = (address) => {
  if (!address) return { city: '', location: '' };

  const parts = address.split(',').map((p) => p.trim());

  if (parts.length < 2) return { city: '', location: '' };

  const last = parts[parts.length - 1];
  const secondLast = parts[parts.length - 2];
  const thirdLast = parts[parts.length - 3];

  const countryCode = last.slice(0, 2).toUpperCase();

  if (countryCode === 'US' || last.toUpperCase() === 'USA') {
    return {
      city: thirdLast || '',
      location: secondLast || '',
    };
  }

  return {
    city: secondLast || '',
    location: countryCode,
  };
};
